import { ColumnDef } from "@tanstack/react-table";
import { getUserFullName } from "@/core/utils/name";
import { DetailedUser } from "@/user/user.d";

export const NameCol = (): ColumnDef<DetailedUser> => ({
  header: "User name",
  accessorFn: (row) => getUserFullName(row),
  size: 150,
  minSize: 100,
});
